import Entity from '../../components/entity';
import {
  OverdueObligationsTable,
  PaidObligationsTable,
  UpcomingObligationsTable,
} from '../../components/tables/ObligationsTable';

const ObligationsPane = () => {
  const subtitle = 'This page is under development and the information displayed may not be accurate.';
  return (
    <Entity.Pane>
      <Entity.Header title="Bills & Subscriptions" subtitle={subtitle} />
      <Entity.Body
        leftColumn={
          <>
            <OverdueObligationsTable />
            <UpcomingObligationsTable />
            <PaidObligationsTable />
          </>
        }
      />
    </Entity.Pane>
  );
};

export default ObligationsPane;
